export default {
    en: {
        tab: {
            book: 'Book',
            tbd: 'Book(TBD)',
            over: 'Book(Carryover)',
        },

        list: {
            bookGubun: 'Classification of Book',
            bookNm: 'Title of Book',
            issueOrg: 'Publisher',
            issueDt: 'Date of Publication',
        },

        detail: {
            bookNm: 'Title of Book',
            bookGubun: 'Classification of Book',
            score2 : 'Maximum Point',
            score2Desc: 'The maximum point based on single author. The final point is determined by personnel committee\'s review including considering maximum point and the number of author.',
            issueOrg: 'Publisher',
            issueDt: 'Date of Publication',
            countryIo: 'Domestic/International',
            rvsnYn: 'Edition',
            mkoutLangCd: 'Language',
            dlgtAthrNm: 'Lead author',
            roleCd: 'Mode of Participation and Role',
            score: 'Points',

            tbd: {
                issueDt: 'Expected Publication Date',
            }
        },

        help:{
            book:{
                line1:'저역서는 초판만 반영됩니다(재판 이상은 연구업적의 중복사용으로 판단).',
                line2:'If a book approved by YRI need to be registered as a book chapter, add the achievement in the Article-Book Chapter menu and click the \'Not Applicable\' on the same achievement in the book menu.',
            },
            tbd:{
                title:'Notes',
                line1:'The Faculty Achievement Report shows all carryover achievements registered on this menu regardless of the evaluation period. If you need to exclude the carryover achievements on the report, then you must delete them in this menu. ',
            },
            over:{
                title: 'How to carryover articles ',
                titleStrong:'[only for pay-rasie and reappointment evaluation, and articles, books, creative activities]',
                line1: 'When articles and books are confirmed to be published after college/gradschool\'s personnel committee and the faculty member fails to include them in pay-raise or reappointment evaluation, the achievements can be carried over for next pay-raise or reappointment evaluation.',
                line2: 'Please note that achievements cannot be carried over in case of promotion evaluation.',
                line3: 'The Faculty Achievement Report shows all carryover achievements registered on this menu regardless of the evaluation period. If you need to exclude the carryover achievements on the report, then you must delete them in this menu. ',
                line4: '*Faculty Performance Evaluation Detailed Rules Article 24 (Definition of Research Results and Limitations for Acknowledgement)',
            },
            numOfAuthors:{
                offCampus:{
                    confirm:{
                        1:'Approved in advance',
                        2:': Number of domestic Institutional faculty/Researcher',
                    },
                    notConfirm:{
                        1:'Not Approved',
                        2:': Total number of domestic and foreign Institutional faculty/Researcher',
                    }
                },
                abCampus:{
                    confirm:{
                        1:'Approved in advance',
                        2:': Number of foreign Institutional faculty/Researcher',
                    },
                    notConfirm:{
                        1:'Not Approved',
                        2:': Blank (0)',
                    }
                },
                line1:{
                    1:'When calculating evaluation points of group research, the number of researchers participating in the international group research affiliated with overseas universities or institutions ',
                    2:'can be excluded upon obtaining a permission from the dean of the affiliated college.',
                    3:'(Faculty Performance Evaluation Detailed Rules Article 40 Clause 1)',
                    example: 'e.g.  The total number of authors for a research achievement with two (2) Yonsei full-time faculty members and one (1) \'A University\' faculty member from United States is three (3). However, with the permission from the dean for the exclusion of the foreign researcher, the total number of authors can be reduced to two (2).'
                },
                line2: 'If you have obtained a permission from the dean of the affiliated college, fill out the number of domestic Institutional faculty/Researcher in the"Off-Campus 1" section and the number of foreign Institutional faculty/Researcher in the"Off-Campus 2" section.',
            },
        }

    },
    ko: {
        tab: {
            book: '저역서',
            tbd: '저역서(출판예정)',
            over: '저역서(이월)',
        },

        list: {
            bookGubun: '저역서구분',
            bookNm: '저역서명',
            issueOrg: '발행처명',
            issueDt: '발행년월',
        },

        detail: {
            bookNm: '저역서명',
            bookGubun: '저역서구분',
            score2 : '최대평점',
            score2Desc: '이 점수는 단독저자 기준의 최대 평점으로서 인사위원회 결과 점수는 하향조정될 수 있습니다. 최종 점수는 최대평점과 저자수를 고려하여 결정됩니다.',
            issueOrg: '발행처',
            issueDt: '발행년월',
            countryIo: '발행지 구분',
            rvsnYn: '개정여부',
            mkoutLangCd: '작성언어',
            dlgtAthrNm: '대표저자',
            roleCd: '참여형태 및 역할',
            score: '최종점수',

            tbd: {
                issueDt: '발행예정년월',
            }
        },

        help:{
            book:{
                line1:'저역서는 초판만 반영됩니다(재판 이상은 연구업적의 중복사용으로 판단).',
                line2:'저역서를 논문 Book Chapter로 인정받으시려면, 해당 Book Chapter를 논문-Book Chapter 탭에 입력하신 후, 이 페이지 해당 저역서의 심사반영여부를 반드시 "심사제외"로 클릭하시기 바랍니다.',
            },
            tbd:{
                title:'저역서(출판예정) 사용 안내',
                line1:'이 탭에 입력한 연구업적은 업적심사기간에 상관없이 업적보고서에 표시될 수 있습니다. 만약 업적심사에 반영하지 않으시려면 반드시 삭제하셔야 합니다.',
            },
            over:{
                title: '연구업적 이월 사용 안내',
                titleStrong:'[승봉/재임용 심사 및 논문/저술/창작활동에 한함]',
                line1: '논문 및 저술이 업적이 대학(원)인사위원회 개최 후 게재,출판이 확정되어 승봉심사와 재임용심사에서 사용하지 못하였을 경우 각각 차기 승봉심사와 재임용심사에 이월하여 사용할 수 있습니다.',
                line2: '승진심사의 경우 업적을 이월할 수 없으니 유의하시기 바랍니다.',
                line3: '이 탭에 입력한 연구업적은 업적심사기간에 상관없이 업적보고서에 표시될 수 있습니다. 만약 업적심사에 반영하지 않으시려면 반드시 삭제하셔야 합니다.',
                line4: '관련 근거 : 「교원업적평가 시행세칙」 제24조(연구실적물의 정의와 인정범위) 제7항',
            },
            numOfAuthors:{
                offCampus:{
                    confirm:{
                        1:'사전승인시',
                        2:': 국내기관교원/연구원 수만 기재',
                    },
                    notConfirm:{
                        1:'사전미승인시',
                        2:': 국내외기관교원/연구원 총원 기재',
                    }
                },
                abCampus:{
                    confirm:{
                        1:'사전승인시',
                        2:': 국외기관교원/연구원 수만 기재',
                    },
                    notConfirm:{
                        1:'사전미승인시',
                        2:': 공란 처리',
                    }
                },
                line1:{
                    1:'공동연구에 대한 평가점수 산정시 해외 대학 혹은 기관에 소속되어 국제간공동연구로 참여하는 연구자의 수는 ',
                    2:'소속 대학 내부 절차에 따라 소속 대학(원)장의 승인을 얻어 포함하지 않을 수 있습니다.',
                    3:'(근거 : 「교원업적평가 시행세칙」 제40조 제1항)',
                    example: '예 : 본교 전임교원 2명과 미국 A 대학 교원 1명과의 공동연구 결과물의 총 참여 저자는 3명이지만, 공동연구 점수환산 시 2명으로 인정함'
                },
                line2: '소속 대학(원)장의 승인을 받은 경우, 교외 1에는 국내 소재 기관 소속 교원/연구원 수를 입력하고 교외 2에 해외 소재 기관 소속 교원/연구원 수를 입력합니다.',
            },
        }
    }
}